import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../../utils/constants";
import useFetch from "../../hooks/useFetch";
import ReusableTable from "../../components/ReusableTable";
import LoadingSpinner from "../../components/LoadingSpinner";
import ClearForm from "../../components/Clearform";
import CustomStepper from "../../components/CustomStepper";
import { readErrorMessage } from "../../utils/apiError";

const GenerateAppointmentLtr = () => {
  const {
    data: draftNotCreatedData,
    loading: loading1,
    error: error1,
    fetchData,
  } = useFetch();
  const [refNotCreatedLots, setRefNotCreatedLots] = useState([]);
  const [receivedData, setReceivedData] = useState([]);
  const [selectedLotNo, setSelectedLotNo] = useState([]);
  const [selectedClientID, setSelectedClientID] = useState([]);
  const [selectedProductID, setSelectedProductID] = useState([]);
  const [selectedArbitratorID, setSelectedArbitratorID] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [showPDF, setShowPDF] = useState(false);
  const [upload, setUpload] = useState(false);
  const [clearForm, setClearForm] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  //   for pagination of reusable table starts
  const [getData, setGetData] = useState([]);
  const [currentPage1, setCurrentPage1] = useState(1); // Current page for ReusableTable
  const [itemsPerPage] = useState(10); // Number of items per page
  const totalItems1 = getData.length;
  const totalPages1 = Math.ceil(totalItems1 / itemsPerPage);
  const startIndex1 = (currentPage1 - 1) * itemsPerPage;
  const currentItems1 = getData.slice(startIndex1, startIndex1 + itemsPerPage);
  const pageNumbers1 = Array.from({ length: totalPages1 }, (_, i) => i + 1);
  //   for pagination of reusable table ends

  // for pagination of reusabletableFixed
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(refNotCreatedLots.length / 10); // Example calculation
  const displayedPages = Array.from({ length: totalPages }, (_, i) => i + 1); // Example pagination logic
  const startIndex = (currentPage - 1) * 10;

  const [searchTerm, setSearchTerm] = useState("");
  const rowsPerPage = 10;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // for pagination of reusabletableFixed

  useEffect(() => {
    const fetchRefNotCreatedLots = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/pendingRefLots`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const result = await response.json();
        setRefNotCreatedLots(result);
      } catch (error) {
        // setError1(error.message);
      }
    };

    fetchRefNotCreatedLots();
  }, []);

  console.log(refNotCreatedLots);

  const searchFields = ["arbName", "Lots"];

  const filteredLots = refNotCreatedLots.filter((item) =>
    searchFields.some((key) =>
      item[key]?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredLots.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    if (draftNotCreatedData.length > 0) {
      const updatedData = draftNotCreatedData.map((item, index) => {
        const {
          SR_No,
          assign_id,
          Arbitrator_id,
          Case_id,
          UPLODED_DATE,
          ...rest
        } = item;
        return {
          // SrNo: index + 1,
          ...rest,
        };
      });

      console.log(updatedData);
      setReceivedData(draftNotCreatedData);
      setGetData(updatedData);
      setShowTable(true);
      //   handleStepChange(1);
    }
  }, [draftNotCreatedData]); // Watch for changes in draftNotCreatedData

  // console.log(getData);

  //   for the getting data of selected lot to create refernce Draft starts

  const handleRowAction = async (item) => {
    console.log(item);
    setSelectedLotNo(item.lotNo);
    setSelectedClientID(item.clientId);
    setSelectedProductID(item.productId);
    setSelectedArbitratorID(item.arbId);
    const url = `${API_BASE_URL}/api/RefLots?lotNo=${item.lotNo}&clientId=${item.clientId}&productId=${item.productId}&arbId=${item.arbId}`;
    setLoading(true);
    try {
      await fetchData(url);
      handleStepChange(1);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  //   for the getting data of selected lot to create refernce Draft ends

  // for the generation of dearft function starts
  const handleGenerateDraft = async () => {
    setLoading(true); // Start loading before fetching data
    try {
      // Fetch the PDF file from the API
      const response = await fetch(
        `${API_BASE_URL}/api/Refletter?lotNo=${selectedLotNo}&clientId=${selectedClientID}&productId=${selectedProductID}&arbId=${selectedArbitratorID}`
      );
      console.log(response);

      if (!response.ok) {
        throw new Error(await readErrorMessage(response));
      }
      // Convert the response to a Blob
      const pdfBlob = await response.blob();
      console.log(pdfBlob);
      // Create a URL for the Blob
      const pdfUrl1 = URL.createObjectURL(pdfBlob);
      console.log(pdfUrl);
      // Set the PDF URL to the state
      setPdfUrl(pdfUrl1);
      // setPdfUrl(pdfUrl);
      setShowPDF(true);
      setUpload(true);
      handleStepChange(2);
    } catch (error) {
      console.error("Error fetching and displaying the PDF:", error);
      window.alert(`The appointment letter could not be made:\n${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  // for the generation of draft function ends


  //   function to upload the reference Drafts Starts Here
  const handleUploadDraft = async () => {
    setLoading(true);

    try {
      // First API call
      const firstResponse = await fetch(
        `${API_BASE_URL}/api/SaveRef?lotNo=${selectedLotNo}&clientId=${selectedClientID}&productId=${selectedProductID}&arbId=${selectedArbitratorID}`
      );

      if (!firstResponse.ok) {
        const errorText = await firstResponse.text();
        throw new Error(
          `Failed to upload data to SaveRef: ${firstResponse.status} ${firstResponse.statusText} - ${errorText}`
        );
      }

      const firstResult = await firstResponse.text(); // Process the response if needed
      // console.log("First API call successful:", firstResult);

      // Second API call (only if the first call is successful)
      const secondResponse = await fetch(
        `${API_BASE_URL}/api/SaveRefCase?lotNo=${selectedLotNo}&clientId=${selectedClientID}&productId=${selectedProductID}&arbId=${selectedArbitratorID}`
      );

      if (!secondResponse.ok) {
        const errorText = await secondResponse.text();
        throw new Error(
          `Failed to upload data to SaveRefCase: ${secondResponse.status} ${secondResponse.statusText} - ${errorText}`
        );
      }

      const secondResult = await secondResponse.text(); // Process the response if needed
      // console.log("Second API call successful:", secondResult);

      setClearForm(true);
      handleStepChange(3); // or handleStepChange(4) depending on your requirement
    } catch (error) {
      console.error("Error uploading data:", error);
      window.alert(`The appointment letters could not be saved:\n${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  //   function to upload the reference Drafts ends Here

  // Loading Spinner Compenent
  if (loading) return <LoadingSpinner />;

  // for pagination of reusabletableFixed starts
  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const columnsWithArbName = [
    { header: "Sr No", key: "Sr No" },
    { header: "Lots", key: "Lots" },
    { header: "Arbitrator", key: "Arb_name" },
    { header: "Actions", key: "action" },
  ];
  // for pagination of reusabletableFixed ends

  // For the customStepper starts Here
  const steps = [
    "Select Lot",
    "Generate Appointment Letter",
    "Upload Appointment Letter",
  ];

  // Function to move to a specific step in Stepper Component
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  // For the customStepper ends Here

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 mb-3">
          <CustomStepper steps={steps} activeStep={activeStep} />
        </div>
      </div>

      <div className="row align-items-center">
        <div className="col-md-6">
          {!showTable ? <h5>Generate Appointment Letter</h5> : ""}
          {showTable && !showPDF && !clearForm && (
            <h6>Generate Appointment Letter</h6>
          )}
          {showPDF && !clearForm && <h5>Upload Appointment Letter</h5>}
        </div>

        {!showTable ? <div className="col-md-4"></div> : ""}
        <div className="col-md-4"> {!showTable ? "" : ""}</div>

        <div className="col-md-2">
          {showTable && !showPDF && !clearForm && (
            <button className="custBtn" onClick={handleGenerateDraft}>
              Generate
            </button>
          )}
          {showPDF && !clearForm && (
            <button className="custBtn" onClick={handleUploadDraft}>
              Upload
            </button>
          )}
        </div>
      </div>

      {!showTable && (
        <div className="row table-container mt-1">
          <div className="col-md-12 mx-auto table-wrapper">
            {/* Search Input */}
            <div className="mb-1 d-flex justify-content-end">
              <input
                type="text"
                placeholder="Search Lots..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1); // reset to first page on search
                }}
                className="form-control p-1"
                style={{ maxWidth: "300px", fontSize: "10px" }}
              />
            </div>

            {/* Table */}
            <table className="responsive-table">
              <thead className="text-center">
                <tr className="table-info">
                  <th scope="col" className="text-center">
                    Sr No
                  </th>

                  <th scope="col" className="text-center">
                    Assigned Date
                  </th>

                  <th scope="col" className="text-center">
                    Lots
                  </th>
                  <th scope="col" className="text-center">
                    Arbitrator Name
                  </th>
                  <th scope="col" className="text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentRows.length > 0 ? (
                  currentRows.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center p-0">
                        {indexOfFirstRow + index + 1}
                      </td>
                      <td className="text-center p-0">
                        {item.assignDate
                          ? new Date(item.assignDate).toLocaleDateString(
                            "en-GB",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )
                          : ""}
                      </td>
                      <td className="text-center p-0">{item.Lots}</td>
                      <td className="text-center p-0">{item.arbName}</td>
                      <td className="text-center p-1">
                        <button
                          onClick={() => handleRowAction(item)}
                          className="custBtn"
                        >
                          Show
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center text-muted">
                      No results found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            <div className="d-flex justify-content-center p-2" >
              <nav>
                <ul className="pagination">
                  {Array.from({ length: totalPages }, (_, i) => (
                    <li
                      key={i + 1}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""
                        }`}

                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(i + 1)}
                        style={{ fontSize: "12px" }}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}

      {showTable && !showPDF && (
        <ReusableTable
          data={currentItems1}
          currentPage={currentPage1}
          pageNumbers={pageNumbers1}
          setCurrentPage={setCurrentPage1}
        />
      )}

      {showPDF && !clearForm && (
        <div className="row mt-3">
          <div className="col-md-12">
            <iframe
              src={pdfUrl}
              style={{ width: "100%", height: "100vh" }}
              title="PDF Viewer"
            />
          </div>
        </div>
      )}

      {clearForm && (
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center ">
            <ClearForm
              message="Appointment Letter Uploaded Successfully!"
              redirectPath="/instdashboard"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default GenerateAppointmentLtr;
